var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#4D7AD2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2273_699)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.8409 11.3859C24.6282 10.595 24.0046 9.97153 23.2138 9.75856C21.7691 9.36328 15.9903 9.36328 15.9903 9.36328C15.9903 9.36328 10.2117 9.36328 8.76705 9.74358C7.99147 9.95632 7.35269 10.5951 7.13995 11.3859C6.75977 12.8304 6.75977 15.8263 6.75977 15.8263C6.75977 15.8263 6.75977 18.8372 7.13995 20.2667C7.35291 21.0574 7.97626 21.6809 8.76716 21.8939C10.2269 22.2893 15.9905 22.2893 15.9905 22.2893C15.9905 22.2893 21.7691 22.2893 23.2138 21.909C24.0047 21.6961 24.6282 21.0727 24.8411 20.2819C25.2212 18.8372 25.2212 15.8415 25.2212 15.8415C25.2212 15.8415 25.2364 12.8304 24.8409 11.3859ZM14.1505 18.5939V13.0586L18.9558 15.8263L14.1505 18.5939Z",
    fill: "#DADADA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2273_699"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.6923,
    height: 19.6923,
    fill: "white",
    transform: "translate(6.15381 6.15381)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.7f88d5db2381c2e168d5b84038d3b309.svg";
export { ForwardRef as ReactComponent };